module.exports = __webpack_public_path__ + "static/img/5.0f3e69c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/5.png
// module id = GgEi
// module chunks = 2